export default __webpack_public_path__ + "static/5-4082f91ccb1a302f1d43323284486c07.jpg";